import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Route } from 'react-router-dom'
import { verifyTokenAction } from '../../redux/actions/auth.action'
import FullPageSpinner from '../../components/FullPageSpinner'

export default function ProtectedRoute(props) {
  const dispatch = useDispatch()

  const { verifyTokenPending, isAuthenticated } = useSelector(
    (state) => state.authStates,
  )

  useEffect(() => {
    dispatch(verifyTokenAction())
  }, [dispatch])

  const { component: Component, ...rest } = props

  return (
    <Route
      {...rest}
      render={(props) =>
        !isAuthenticated && verifyTokenPending ? (
          <FullPageSpinner></FullPageSpinner>
        ) : (
          <Component {...props} />
        )
      }
    />
  )
}
